/**
 * useEdgeStatus Hook (Web)
 * Thin wrapper around shared useEdgeStatus
 */

import { useAuth } from '@contexts/AuthContext';
import { createHttpClient } from '@parlay-picker/shared/api/httpClient';
import type { EdgeStatusView } from '@parlay-picker/shared/edgeStatus';
import { useEdgeStatus as useEdgeStatusShared } from '@parlay-picker/shared/hooks/useEdgeStatus';
import { useMemo } from 'react';
import { API_BASE_URL } from '../config/api';

export function useEdgeStatus(): EdgeStatusView | null {
  const { authFetch, user } = useAuth();
  const httpClient = useMemo(
    () => createHttpClient({ authFetch, baseUrl: API_BASE_URL }),
    [authFetch],
  );
  return useEdgeStatusShared({ httpClient, userId: user?.id ?? null });
}
